<template>
  <div v-if="entry.performedByName || tasks.length" class="proof-entry-details">
    <div v-if="entry.performedByName" class="d-flex align-center text-body-2 mb-1">
      <v-icon small class="mr-1">mdi-account</v-icon>
      {{ entry.performedByName }}
    </div>
    <div v-if="tasks.length">
      <div
        v-for="(task, idx) in tasks"
        :key="idx"
        class="d-flex align-center text-body-2"
        :class="{ 'text--secondary': !task.completed }"
      >
        <v-icon small class="mr-1" :color="task.completed ? 'success' : 'grey'">
          {{ task.completed ? "mdi-checkbox-marked-circle" : "mdi-checkbox-blank-circle-outline" }}
        </v-icon>
        {{ task.task }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "proofEntryDetails",
  props: {
    entry: { type: Object, required: true },
  },
  computed: {
    tasks() {
      return Array.isArray(this.entry.checklist) ? this.entry.checklist : [];
    },
  },
};
</script>
